export default __webpack_public_path__ + "static/media/kareya-saleh.68310e00.jpg";